/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userfirstname2Inputs */

const en_entity_userfirstname2 = /** @type {(inputs: Entity_Userfirstname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User First Name`)
};

const de_entity_userfirstname2 = /** @type {(inputs: Entity_Userfirstname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "User First Name" |
*
* @param {Entity_Userfirstname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userfirstname2 = /** @type {((inputs?: Entity_Userfirstname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userfirstname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userfirstname2(inputs)
	return de_entity_userfirstname2(inputs)
});
export { entity_userfirstname2 as "entity_userFirstName" }